var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-dialog",
    {
      attrs: { value: _vm.visible, "full-width": true, square: "" },
      on: { hide: _vm.hide }
    },
    [
      _c(
        "q-card",
        { staticClass: "pallet-log-list" },
        [
          _c("dialog-header", {
            attrs: { "dialog-title": _vm.name, "raw-title": true },
            on: { close: _vm.hide }
          }),
          _vm._v(" "),
          _c(
            "q-card-section",
            [
              _c("pallet-log-list", {
                attrs: { pallet: _vm.pallet },
                on: { hide: _vm.hide }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }